import {Account, Cred} from '.';
import {Opportunity} from './opportunity';

export enum JobApplicationStatus {
  INVITED = 'INVITED',
  APPLIED = 'APPLIED',
  WITHDRAWN = 'WITHDRAWN',
  REJECTED = 'REJECTED',
  ACCEPTED = 'ACCEPTED',
}

export class JobApplication {
  id: string;
  account: Account;
  cred: Cred;
  opportunity: Opportunity;
  recco?: Cred;
  status: JobApplicationStatus;
  createdAt: string;
  updatedAt: string;
  auraScore?: number;
  matchExplanation?: string;
  matchedCreds?: Cred[];
  matchedReccos?: Cred[];
  note?: string;

  constructor(json: any) {
    this.id = json.id || json._id;
    this.account = json.account ? new Account(json.account) : ({} as Account);
    this.cred = json.cred ? new Cred(json.cred) : ({} as Cred);
    this.opportunity = json.opportunity ? new Opportunity(json.opportunity) : ({} as Opportunity);
    this.recco = json.recco ? new Cred(json.recco) : undefined;
    this.status = json.status;
    this.createdAt = json.createdAt;
    this.updatedAt = json.updatedAt;
    this.auraScore = json.auraScore;
    this.matchExplanation = json.matchExplanation;
    this.note = json.note;
    this.matchedCreds =
      json.matchedCreds?.map((cred: any) => {
        const credData = cred._id || cred;
        return new Cred(credData);
      }) || [];
    this.matchedReccos =
      json.matchedReccos?.map((recco: any) => {
        const reccoData = recco._id || recco;
        return new Cred(reccoData);
      }) || [];
  }
}

export interface CreateJobApplication {
  accountId: string;
  credId: string;
  opportunityId: string;
  reccoId?: string;
  status?: JobApplicationStatus;
}

export interface UpdateJobApplication {
  status?: JobApplicationStatus;
}
